module.exports = __webpack_public_path__ + "static/media/AngeloSpencerAlbumCoverSquare.c14fa762.jpg";